type Locale = 'en' | 'es';
type Phrase = (l: Locale) => string;

// eslint-disable-next-line camelcase
export const i18n_classes_seo_description: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `High-quality yoga classes online to meet you where you are, on your schedule. Start your wellness journey with a free 7-day trial today.`,
    es: `Elige entre cientos de clases de yoga y rutinas para ver en línea. Comience su viaje de bienestar con una prueba gratuita de 7 días hoy.`,
  };
  return phrases[locale] || phrases.en || '';
};
